module.exports = __webpack_public_path__ + "img/good-02.9ed17514.png";